import { render, staticRenderFns } from "./decimal-input.vue?vue&type=template&id=4644f1ed"
import script from "./decimal-input.vue?vue&type=script&lang=js"
export * from "./decimal-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports